import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import customerService from '@/services/customer'
import { phoneFormatFilterInternational } from '@/utils/phone'
import DialogContentLayout from "@/components/common/DialogContentLayout.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SMSConfimationContent',
  props: {
    customerId: null,
    phone: null
  },
  emits: ["confirm", "retry"],
  setup(__props: any, { emit }) {

const props = __props as {
  customerId: number;
  phone: string;
};

const verified = ref(false);
const submitting = ref(false);
const errorMessage = ref("");
const shake = ref(false);
const mfaCode = ref("");




 const formattedPhone = computed(() => {
    if (!props.phone) {
      return ''
    }
    return phoneFormatFilterInternational(props.phone)
  })

const submit = async () => {
  submitting.value = true;
  try {
    await customerService.verifySMS(props.customerId, {
      phoneNumber: props.phone,
      code: mfaCode.value.toString(),
    });
    verified.value = true;
    setTimeout(() => {
      emit("confirm");
    }, 2000);
  } catch (err) {
    errorMessage.value =
      "Could not validate phone number. Please make sure your code is correct and try again.";
    console.error(err);
    shake.value = true;
    setTimeout(() => {
      shake.value = false;
    }, 1500);
  }
  submitting.value = false;
};

return { __sfc: true,verified, submitting, errorMessage, shake, mfaCode, props, emit, formattedPhone, submit, DialogContentLayout }
}

})